import { Fragment, memo } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { SubscriptionSearchFamilyCrumbs } from 'subscription/constants/breadcrumb';
import ActionsList from './actions';
import PersonSearch from 'shell/components/shared/person-search';
import { Typography } from '@mui/material';

interface FamilyPageProps {
  isWithoutBreadcrumbs?: boolean;
  goBackUrl?: string;
  pathname?: string; // destination url
}

const FamilyPageComponent = ({
  isWithoutBreadcrumbs = false,
  goBackUrl,
  pathname = '/iscrizioni/famiglia/nascita',
}: FamilyPageProps): React.ReactElement => {
  return (
    <Fragment>
      {isWithoutBreadcrumbs ? undefined : <Breadcrumbs items={SubscriptionSearchFamilyCrumbs} />}
      <PersonSearch
        pathname={pathname}
        action={ActionsList}
        addedTitle="- Iscrizione Nascita Famiglia"
        goBackUrl={goBackUrl}
      />
      <Typography>Comunicare i dati identificativi del C.F. o di un familiare</Typography>
    </Fragment>
  );
};

FamilyPageComponent.displayName = 'Family page component';

const FamilyPage = memo(FamilyPageComponent);

export default FamilyPage;
